/* eslint-disable camelcase */

export const color = {
  white: '#ffffff',
  black: '#000000',
  dark_gray: '#444444',
  gray: '#888888',
  thin_gray: '#AAAAAA',
  ash_gray: '#c0c0c0',
  light_gray: '#f9f9f9',
  border_gray: '#cccccc',
  border_gray_dark: '#dddddd',
  bg_gray: '#e6eaf0',
  bg_gray_dark: '#D9D9D9',
  bg_pale_green: '#F7FFFF',
  bg_light_green: '#E3F3F3',
  bg_light_gray: '#EDEDED',
  input_gray: '#d0d0d0',
  button_gray: '#e7e7e7',
  table_gray: '#ededed',
  blue: '#7bd6e7',
  light_blue: '#00CAFA ',
  light_yellow: '#FFF1CC',
  light_orange: '#FFE2BF',
  green: '#0cb2b4',
  red: '#eb3223',
  alert_red: '#fadbda',
  vermilion: '#ED6C4F',
  light_green: '#e5f3f4',
  table_green: '#80cfd4',
  notification_red: '#E53935',
  notification_red_bg: '#FAEFEF',
  notification_pink: '#FF7F97',
  notification_pink_bg: '#FAEEF1',
  notification_yellow: '#FFBB00',
  notification_yellow_bg: '#FCF6DC',
  notification_orange: '#FF8900',
  notification_orange_odor: '#FF8A00',
  notification_orange_bg: '#FFF7ED',
  notification_green: '#49BE37',
  notification_green_bg: '#EFFCED',
  graph_purple: '#9B6DCA',
  graph_green: '#44CA15',
  light_pink: '#FFE9ED',
  light_black: '#323232',
  brown: '#AE8315',
  notification_navy: '#484C75',
  notification_navy_bg: '#DFE2FF',
  md_button_bg: '#F2F2F2',
  md_chat_blue: '#62A4D9',
  md_nav_active_bg: '#8EC2EC',
  md_bg_blue: '#DCECF8',
  md_bg_light_blue: '#EEF8FF',
};
